import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { AuthorizationService } from '../services/authorization.service';
import { LegendaryService } from '../services/legendary.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'settings-form',
    template: require('./legendary-settings.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class LegendarySettingsComponent {
    settingsForm: FormGroup;
    loggedIn: boolean = false;
    useCustom: boolean = false;

    constructor(private fb: FormBuilder, private auth: AuthorizationService, private legendaryService: LegendaryService) {
        this.loggedIn = auth.isLoggedIn();

        this.createForm();
    }

    ngOnInit() {
        //if (this.loggedIn) {
        this.legendaryService.fetchControls()
                .subscribe(settings => {
                    this.useCustom = settings.useCustom;
                    this.schemeList = settings.schemeList;
                    this.mastermindList = settings.mastermindList;
                    this.heroTeamList = settings.heroTeamList;
                    this.villainList = settings.villainList;
                    this.villainFilter = settings.villainFilter;
                    this.henchmenList = settings.henchmenList;
                    this.henchmenFilter = settings.henchmenFilter;
                    this.heroList = settings.heroList;
                    this.heroFilter = settings.heroFilter;
                    this.mastermindExcludeList = settings.mastermindExcludeList;
                    this.mastermindExcludeFilter = settings.mastermindExcludeFilter;
                    this.schemeExcludeList = settings.schemeExcludeList;
                    this.schemeExcludeFilter = settings.schemeExcludeFilter;
                })

        this.legendaryService.fetchEncountersControls()
                .subscribe(settings => {
                    this.sideListSelect = settings.sideListSelect;
                    this.queenMotherSelect = settings.queenMotherSelect;
                    this.locationListSet = settings.locationListSet;
                    this.locationList = settings.locationList;
                    this.objective1ListSet = settings.objective1ListSet;
                    this.objective2ListSet = settings.objective2ListSet;
                    this.objective3ListSet = settings.objective3ListSet;
                    this.objectiveList = settings.objectiveList;
                    this.crewListTeam = settings.crewListTeam;
                    this.crewList = settings.crewList;
                })

        this.legendaryService.fetchUserSettings()
                .subscribe(settings => {
                    this.settingsForm.patchValue({
                        SmartBoardSelect: settings.SmartBoardSelect,
                        LegendarySets: {
                            Core: (settings.SetsOff.indexOf("Core") > -1) ? false : true,
                            DarkCity: (settings.SetsOff.indexOf("DarkCity") > -1) ? false : true,
                            FantasticFour: (settings.SetsOff.indexOf("FantasticFour") > -1) ? false : true,
                            PaintTheTownRed: (settings.SetsOff.indexOf("PaintTheTownRed") > -1) ? false : true,
                            GuardiansOfTheGalaxy: (settings.SetsOff.indexOf("GuardiansOfTheGalaxy") > -1) ? false : true,
                            SecretWarsVol1: (settings.SetsOff.indexOf("SecretWarsVol1") > -1) ? false : true,
                            SecretWarsVol2: (settings.SetsOff.indexOf("SecretWarsVol2") > -1) ? false : true,
                            CaptainAmerica: (settings.SetsOff.indexOf("CaptainAmerica") > -1) ? false : true,
                            CivilWar: (settings.SetsOff.indexOf("CivilWar") > -1) ? false : true,
                            Deadpool: (settings.SetsOff.indexOf("Deadpool") > -1) ? false : true,
                            Noir: (settings.SetsOff.indexOf("Noir") > -1) ? false : true,
                            XMen: (settings.SetsOff.indexOf("XMen") > -1) ? false : true,
                            Homecoming: (settings.SetsOff.indexOf("Homecoming") > -1) ? false : true,
                            Champions: (settings.SetsOff.indexOf("Champions") > -1) ? false : true,
                            WorldWarHulk: (settings.SetsOff.indexOf("WorldWarHulk") > -1) ? false : true,
                            Phase1: (settings.SetsOff.indexOf("Phase1") > -1) ? false : true,
                            AntMan: (settings.SetsOff.indexOf("AntMan") > -1) ? false : true,
                            VillainsSet: (settings.SetsOff.indexOf("VillainsSet") > -1) ? false : true,
                            FearItselfSet: (settings.SetsOff.indexOf("FearItselfSet") > -1) ? false : true,
                            BigTrouble: (settings.SetsOff.indexOf("BigTrouble") > -1) ? false : true,
                            Buffy: (settings.SetsOff.indexOf("Buffy") > -1) ? false : true,
                            CustomSet: (settings.SetsOff.indexOf("CustomSet") > -1) ? false : true
                        },
                        ExcludedHeroes: settings.ExcludedHeroes,
                        ExcludedPlots: settings.ExcludedPlots,
                        ExcludedMasterminds: settings.ExcludedMasterminds,
                        ExcludedHenchmen: settings.ExcludedHenchmen,
                        ExcludedVillains: settings.ExcludedVillains,
                        PlayableMastermind: settings.PlayableMastermind,
                        PlayableMastermindDeck: settings.PlayableMastermindDeck,
                        AllyMatchMastermind: settings.AllyMatchMastermind,
                        HeroOpposeMastermind: settings.HeroOpposeMastermind,
                        SchemeMatchMastermind: settings.SchemeMatchMastermind,
                        TransmogrifiedMastermindDeck1: settings.TransmogrifiedMastermindDeck1,
                        TransmogrifiedMastermindDeck2: settings.TransmogrifiedMastermindDeck2,
                        TransmogrifiedMastermindDeck3: settings.TransmogrifiedMastermindDeck3,
                        TransmogrifiedHero1: settings.TransmogrifiedHero1,
                        TransmogrifiedHero2: settings.TransmogrifiedHero2,
                        TransmogrifiedHero3: settings.TransmogrifiedHero3,
                        TransmogrifiedHero4: settings.TransmogrifiedHero4,
                        TransmogrifiedHero5: settings.TransmogrifiedHero5,
                        TransmogrifiedHero6: settings.TransmogrifiedHero6,
                        TransmogrifiedPlot: settings.TransmogrifiedPlot,
                        TransmogrifiedMastermind: settings.TransmogrifiedMastermind,
                        TransmogrifiedHenchmen: settings.TransmogrifiedHenchmen,
                        TransmogrifiedVillainGroups: settings.TransmogrifiedVillainGroups,
                        TransmogrifiedHenchmenSetting: settings.TransmogrifiedHenchmenSetting,
                        TransmogrifiedVillainSetting: settings.TransmogrifiedVillainSetting,
                        PlayerAliens: settings.PlayerAliens,
                        HiddenAgendas: settings.HiddenAgendas,
                        OneRipley: settings.OneRipley,
                        ExcludedCrew: settings.ExcludedCrew,
                        ExcludedObjectives: settings.ExcludedObjectives,
                        ExcludedLocations: settings.ExcludedLocations,
                        Crossover: settings.Crossover,
                        TransmogrifiedLocation: settings.TransmogrifiedLocation,
                        TransmogrifiedObjective1: settings.TransmogrifiedObjective1,
                        TransmogrifiedObjective2: settings.TransmogrifiedObjective2,
                        TransmogrifiedObjective3: settings.TransmogrifiedObjective3,
                        TransmogrifiedCrew1: settings.TransmogrifiedCrew1,
                        TransmogrifiedCrew2: settings.TransmogrifiedCrew2,
                        TransmogrifiedCrew3: settings.TransmogrifiedCrew3,
                        TransmogrifiedCrew4: settings.TransmogrifiedCrew4,
                        CrossoverCrew: settings.CrossoverCrew,
                        TransmogrifiedPredator1: settings.TransmogrifiedPredator1,
                        TransmogrifiedPredator2: settings.TransmogrifiedPredator2,
                        TransmogrifiedPredator3: settings.TransmogrifiedPredator3,
                        TransmogrifiedPredator4: settings.TransmogrifiedPredator4,
                        SideSetting: settings.SideSetting,
                        QueenMotherMode: settings.QueenMotherMode,
                        MastermindsAsCommanders: settings.MastermindsAsCommanders,
                        HeroesAsAllies: settings.HeroesAsAllies,
                        VillainsAsAdversaries: settings.VillainsAsAdversaries,
                        HenchmenAsBackup: settings.HenchmenAsBackup,
                        SchemesAsPlots: settings.SchemesAsPlots,
                        EncountersSets: {
                            AlienSet: (settings.SetsOff.indexOf("AlienSet") > -1) ? false : true,
                            AlienExpansionSet: (settings.SetsOff.indexOf("AlienExpansionSet") > -1) ? false : true,
                            PredatorSet: (settings.SetsOff.indexOf("PredatorSet") > -1) ? false : true
                        }
                    });
                })
        //}
    }

    createForm() {
        this.settingsForm = this.fb.group({
            Players: 2,
            PlayableMastermind: false,
            PlayableMastermindDeck: false,
            LegendarySets: this.fb.group({
                Core: true,
                DarkCity: true,
                FantasticFour: true,
                PaintTheTownRed: true,
                GuardiansOfTheGalaxy: true,
                SecretWarsVol1: true,
                SecretWarsVol2: true,
                CaptainAmerica: true,
                CivilWar: true,
                Deadpool: true,
                Noir: true,
                XMen: true,
                Homecoming: true,
                Champions: true,
                WorldWarHulk: true,
                Phase1: true,
                AntMan: true,
                VillainsSet: true,
                FearItselfSet: true,
                BigTrouble: true,
                Buffy: true,
                CustomSet: true
            }),
            ChallengeMode: "Normal",
            MastermindDifficulty: "Standard",
            TransmogrifiedPlot: "Random",
            TransmogrifiedMastermind: "Random",
            AllyMatchMastermind: false,
            TransmogrifiedMastermindDeck1: "Random",
            TransmogrifiedMastermindDeck2: "Random",
            TransmogrifiedMastermindDeck3: "Random",
            TransmogrifiedVillainSetting: "All",
            TransmogrifiedVillainGroups: "",
            TransmogrifiedHenchmenSetting: "All",
            TransmogrifiedHenchmen: "",
            TransmogrifiedHero1: "Random",
            TransmogrifiedHero2: "Random",
            TransmogrifiedHero3: "Random",
            TransmogrifiedHero4: "Random",
            TransmogrifiedHero5: "Random",
            TransmogrifiedHero6: "Random",
            HeroOpposeMastermind: false,
            ExcludedMasterminds: "",
            ExcludedPlots: "",
            ExcludedHenchmen: "",
            ExcludedVillains: "",
            ExcludedHeroes: "",
            SmartBoardSelect: false,
            MastermindsAsCommanders: "",
            SchemesAsPlots: "",
            HenchmenAsBackup: "",
            HeroesAsAllies: "",
            VillainsAsAdversaries: "",
            HiddenAgendas: false,
            OneRipley: false,
            SideSetting: "Random",
            QueenMotherMode: "Random",
            TransmogrifiedLocation: "",
            TransmogrifiedObjective1: "",
            TransmogrifiedObjective2: "",
            TransmogrifiedObjective3: "",
            TransmogrifiedCrew1: "",
            TransmogrifiedCrew2: "",
            TransmogrifiedCrew3: "",
            TransmogrifiedCrew4: "",
            ExcludedLocations: "",
            ExcludedObjectives: "",
            ExcludedCrew: "",
            Crossover: false,
            CrossoverHeroes: "",
            CrossoverCrew: "",
            EncountersSets: this.fb.group({
                AlienSet: true,
                AlienExpansionSet: true,
                PredatorSet: true
            })
        });
    }

    public villainSettingList: Array<string> = ["All", "Villain", "Adversary", "Match"]
    public henchmenSettingList: Array<string> = ["All", "Henchmen", "Backup", "Match"]

    public schemeList: Array<string> = [];
    public mastermindList: Array<string> = [];
    public heroTeamList: Array<string> = [];
    public villainList: Array<string> = [];
    public villainFilter: Array<string> = [];
    public henchmenList: Array<string> = [];
    public henchmenFilter: Array<string> = [];
    public heroList: Array<string> = [];
    public heroFilter: Array<string> = [];
    public mastermindExcludeList: Array<string> = [];
    public mastermindExcludeFilter: Array<string> = [];
    public schemeExcludeList: Array<string> = [];
    public schemeExcludeFilter: Array<string> = [];

    public sideListSelect: Array<string> = [];
    public queenMotherSelect: Array<string> = [];
    public locationListSet: Array<string> = [];
    public locationList: Array<string> = [];
    public objective1ListSet: Array<string> = [];
    public objective2ListSet: Array<string> = [];
    public objective3ListSet: Array<string> = [];
    public crewListTeam: Array<string> = [];
    public objectiveList: Array<string> = [];
    public crewList: Array<string> = [];

    onSubmit() {
        this.legendaryService.userSettingsUpdate(this.settingsForm.value)
            .subscribe(function (data) {
                console.log('received response');
            });
    }

    public handleVillainFilter(value: string) {
        this.villainFilter = this.villainList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleHenchmenFilter(value: string) {
        this.henchmenFilter = this.henchmenList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleMastermindFilter(value: string) {
        this.mastermindExcludeFilter = this.mastermindExcludeList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleSchemeFilter(value: string) {
        this.schemeExcludeFilter = this.schemeExcludeList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleHeroFilter(value: string) {
        this.heroFilter = this.heroList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleCharacterFilter(value: string) {
        this.crewList = this.crewList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/settings/legendary-settings.component.ts